export default __webpack_public_path__ + "static/media/ots.95f1078c.ttf";